// extracted by mini-css-extract-plugin
module.exports = {"facebook":"SocialButton_facebook__JSpdo","leftSection":"SocialButton_leftSection__XIObM"};